<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the topic."
            :error="(errors.name || [])[0]"
        />

        <CkEditorFormGroup
            v-model="data.description"
            name="description"
            label="Description"
            help-text="The description of the topic."
            :error="(errors.description || [])[0]"
        />

        <TextFormGroup
            v-model="data.video_url"
            name="video_url"
            label="Video URL"
            help-text="The URL of a video to attach to the topic."
            :error="(errors.video_url || [])[0]"
        />

        <StaticFormGroup
            v-if="edit"
            :value="data.portal_company_name"
            label="Topic Owner"
        />

        <TypeaheadFormGroup
            v-else
            v-model="data.portal_company_id"
            label="Topic Owner"
            endpoint="/api/v2/portal-companies"
            :params="{'filter[portal_id]': portal.id}"
            :token="shared.token"
            path="data.data"
            placeholder="Search..."
            :result-label-property="row => row.attributes.name || row.attributes.company_name"
        />

        <GalleryFormGroup
            v-model="data.image_id"
            name="image_id"
            label="Image"
            help-text="The image of the topic."
            :error="(errors.image_id || [])[0]"
            :nullable="true"
        />

        <TextFormGroup
            v-model="data.path"
            name="path"
            label="Path"
            help-text="The path of the topic."
            :error="(errors.path || [])[0]"
        />

        <DateFormGroup
            v-model="data.publish_at"
            name="publish_at"
            label="Publish At"
            help-text="The date that the topic should be published."
            :error="(errors.publish_at || [])[0]"
            format="YYYY-MM-DD HH:mm:ss"
            original-format="YYYY-MM-DD HH:mm:ss"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import CkEditorFormGroup from "../../../../vendor/forms/FormGroups/Block/CkEditor"
import DateFormGroup from "../../../../vendor/forms/FormGroups/Block/Date"
import GalleryFormGroup from "../../../FormGroups/Block/Gallery"
import StaticFormGroup from '@/vendor/forms/FormGroups/Block/Static'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {CkEditorFormGroup, DateFormGroup, GalleryFormGroup,StaticFormGroup, SubmitFormGroup, TextFormGroup, TypeaheadFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    },

    edit: {
      required: false,
      default: false
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  }
}
</script>